import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('discardAttachmentPreferencesOption')(function discardAttachmentPreferencesOption(state) {
    var optionState = state.optionState;
    optionState.fromComputer = null;
    optionState.fromOneDrive = null;
}));
//# sourceMappingURL=discardAttachmentPreferencesOption.js.map